function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F6FAFF",
  fillRule: "evenodd",
  d: "M0 0v49.194h40.59V175H98V39.948L58.078 0z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 98,
    height: 175,
    viewBox: "0 0 98 175"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/number1.935c0f9b.svg";
export { SvgComponent as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ./node_modules/svgr/webpack.js!./src/containers/static/landing/number1.svg
// module id = 387
// module chunks = 0